import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { Divider } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { AMember, AMemberInfo, appdata } from '../internalModules';
import UIMemberTable from './UIMemberTable';
import { drawerButtonStyle, drawerWidth } from '../Graphics';
import UIMemberDialog from './UIMemberDialog';

type Props = {
  toggleMembersOpen: Function
  isOpen: boolean
  updateApp: Function
}

export default function UIMemberDrawer({toggleMembersOpen, isOpen, updateApp}: Props) {

  const [dialogOpen, setDialogOpen] = React.useState(false)

  const toggleDialogOpen = (open: boolean) => (event: React.MouseEvent) => {
    setDialogOpen(open)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleAcceptDialog = (info: AMemberInfo) => {
    let member = new AMember(info)
    appdata.createMember(member)
    setDialogOpen(false)
    updateApp()
  }

  return (
    <div>
      <Drawer
        anchor="right"
        variant="temporary"
        open={isOpen}
        onClose={toggleMembersOpen(false)}
      >
        <Box sx={{ width: drawerWidth, height: '100%'}} >
          <Button
            sx={{height: 64}}
            variant={'outlined'}
            endIcon={<ChevronRightIcon />}
            onClick={toggleMembersOpen(false)}
            fullWidth
          >
            Close
          </Button>
          <Divider />
          <Button variant={'contained'} sx={drawerButtonStyle} onClick={toggleDialogOpen(true)}>Create New Member</Button>
          <UIMemberTable updateApp={updateApp}/>          
          <UIMemberDialog memberGuid='' isOpen={dialogOpen} closeDialog={handleCloseDialog} acceptDialog={handleAcceptDialog} />
        </Box>
      </Drawer>
    </div>
  );
}